import React, { useState } from 'react'
import { DisableDates } from '../Datepicker'

import { Mode } from '../enums'
import ModeElement from './ModeElements'

interface IProps {
  selectedDate: Date
  showCurrentDay?: boolean
  enableYearsShift?: boolean
  disableDates?: DisableDates
  disableInModes: Mode[]
  onSelectYear?: (year: number) => void
}

const ModeYears = (props: IProps) => {
  const getFirstYear = () => {
    const current = new Date().getFullYear()
    const start = current + 30
    const last = current - 101

    for (let i = start; i >= last; i -= 30) {
      const nextStep = i - 30
      if (props.selectedDate.getFullYear() <= i && props.selectedDate.getFullYear() > nextStep) {
        return i
      }
    }
    return current
  }

  const [firstYear, setFirstYear] = useState(getFirstYear())
  const lastYear: number = firstYear - 29

  const years: number[] = []
  for (let i = firstYear; i >= lastYear; i--) {
    years.push(i)
  }

  const handlePlusYears = () => {
    setFirstYear(firstYear + 30)
  }

  const handleMinusYears = () => {
    setFirstYear(firstYear - 30)
  }

  return (
    <div className='cs-rdatepicker__mode-content with-buttons'>
      <div className='move-button-container'>
        {props.enableYearsShift && firstYear <= new Date().getFullYear() + 29 && (
          <button type='button' className='move-button' name='plus' onClick={handlePlusYears}>
            <i className='fa fa-arrow-left' />
          </button>
        )}
      </div>
      <table>
        <ModeElement
          mode={Mode.Year}
          values={years}
          selectedDate={props.selectedDate}
          columns={5}
          disableDates={props.disableDates}
          disableFull={props.disableInModes.indexOf(Mode.Year) !== -1}
          onClick={(index: number) => props.onSelectYear && props.onSelectYear(years[index])}
        />
      </table>
      <div className='move-button-container'>
        {props.enableYearsShift && firstYear >= new Date().getFullYear() - 70 && (
          <button type='button' className='move-button' name='plus' onClick={handleMinusYears}>
            <i className='fa fa-arrow-right' />
          </button>
        )}
      </div>
    </div>
  )
}

export default ModeYears
